import { z } from 'zod';

/** Hydrated allergen or dietary tag for editors and site components. */
export const MenuTagRefSchema = z.object({
  id: z.string().min(1),
  iconKey: z.string().nullable(),
  label: z.string(),
});

export type MenuTagRef = z.infer<typeof MenuTagRefSchema>;

export function tagRefsToIds(tags: MenuTagRef[] | string[] | undefined): string[] {
  if (!tags?.length) {
    return [];
  }
  return tags.map((tag) => (typeof tag === 'string' ? tag : tag.id));
}
